/**
 * Mock market data for cryptocurrency trading cards
 * Updated to match actual database trading pairs (15 symbols)
 */

export const mockMarkets = [
  {
    coinName: "BTC",
    symbol: "BTCUSDT",
    displayName: "Bitcoin/USDT",
    currentPrice: 67234,
    priceChange: "+2.34%",
    watchlistCount: 1200,
    participantCount: 1247,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$2.1K', down: '$1.8K' },
      '1h': { up: '$5.4K', down: '$3.2K' },
      '1d': { up: '$12.3K', down: '$8.7K' }
    },
    totalVolume: "$2.3M",
    trend: "up",
    tags: ["Major"]
  },
  {
    coinName: "ETH",
    symbol: "ETHUSDT",
    displayName: "Ethereum/USDT",
    currentPrice: 3456,
    priceChange: "-1.23%",
    watchlistCount: 890,
    participantCount: 856,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$1.8K', down: '$2.1K' },
      '1h': { up: '$3.9K', down: '$4.6K' },
      '1d': { up: '$8.2K', down: '$9.8K' }
    },
    totalVolume: "$890K",
    trend: "down",
    tags: ["Major", "DeFi"]
  },
  {
    coinName: "SOL",
    symbol: "SOLUSDT",
    displayName: "Solana/USDT",
    currentPrice: 178,
    priceChange: "+5.67%",
    watchlistCount: 654,
    participantCount: 2103,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$1.5K', down: '$0.9K' },
      '1h': { up: '$3.2K', down: '$1.8K' },
      '1d': { up: '$7.6K', down: '$4.2K' }
    },
    totalVolume: "$1.8M",
    trend: "up",
    tags: ["Altcoins"]
  },
  {
    coinName: "DOGE",
    symbol: "DOGEUSDT",
    displayName: "Dogecoin/USDT",
    currentPrice: 0.234,
    priceChange: "+12.45%",
    watchlistCount: 2341,
    participantCount: 3421,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$2.8K', down: '$1.2K' },
      '1h': { up: '$5.1K', down: '$2.3K' },
      '1d': { up: '$9.4K', down: '$3.8K' }
    },
    totalVolume: "$650K",
    trend: "up",
    tags: ["Meme"]
  },
  {
    coinName: "ADA",
    symbol: "ADAUSDT",
    displayName: "Cardano/USDT",
    currentPrice: 0.567,
    priceChange: "-0.89%",
    watchlistCount: 432,
    participantCount: 987,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$0.8K', down: '$1.4K' },
      '1h': { up: '$1.9K', down: '$2.8K' },
      '1d': { up: '$3.2K', down: '$5.1K' }
    },
    totalVolume: "$420K",
    trend: "neutral",
    tags: ["Altcoins"]
  },
  {
    coinName: "AVAX",
    symbol: "AVAXUSDT",
    displayName: "Avalanche/USDT",
    currentPrice: 45.67,
    priceChange: "+3.21%",
    watchlistCount: 567,
    participantCount: 1654,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$1.2K', down: '$0.8K' },
      '1h': { up: '$2.9K', down: '$1.7K' },
      '1d': { up: '$6.1K', down: '$3.4K' }
    },
    totalVolume: "$780K",
    trend: "up",
    tags: ["Altcoins", "DeFi"]
  },
  {
    coinName: "BNB",
    symbol: "BNBUSDT",
    displayName: "BNB/USDT",
    currentPrice: 234.56,
    priceChange: "+1.89%",
    watchlistCount: 789,
    participantCount: 1234,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$0.9K', down: '$1.1K' },
      '1h': { up: '$2.1K', down: '$2.4K' },
      '1d': { up: '$4.5K', down: '$5.2K' }
    },
    totalVolume: "$560K",
    trend: "up",
    tags: ["Exchange", "BSC"]
  },
  {
    coinName: "XRP",
    symbol: "XRPUSDT",
    displayName: "XRP/USDT",
    currentPrice: 0.789,
    priceChange: "-2.45%",
    watchlistCount: 345,
    participantCount: 876,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$0.7K', down: '$1.3K' },
      '1h': { up: '$1.6K', down: '$2.7K' },
      '1d': { up: '$3.4K', down: '$5.8K' }
    },
    totalVolume: "$390K",
    trend: "down",
    tags: ["Payment"]
  },
  {
    coinName: "DOT",
    symbol: "DOTUSDT",
    displayName: "Polkadot/USDT",
    currentPrice: 8.91,
    priceChange: "-2.45%",
    watchlistCount: 345,
    participantCount: 876,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$0.7K', down: '$1.3K' },
      '1h': { up: '$1.6K', down: '$2.7K' },
      '1d': { up: '$3.4K', down: '$5.8K' }
    },
    totalVolume: "$390K",
    trend: "down",
    tags: ["Interoperability"]
  },
  {
    coinName: "LINK",
    symbol: "LINKUSDT",
    displayName: "Chainlink/USDT",
    currentPrice: 23.45,
    priceChange: "+4.56%",
    watchlistCount: 678,
    participantCount: 1543,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$1.4K', down: '$0.9K' },
      '1h': { up: '$3.1K', down: '$2.0K' },
      '1d': { up: '$6.8K', down: '$4.3K' }
    },
    totalVolume: "$920K",
    trend: "up",
    tags: ["Oracle", "DeFi"]
  },
  {
    coinName: "UNI",
    symbol: "UNIUSDT",
    displayName: "Uniswap/USDT",
    currentPrice: 12.34,
    priceChange: "-0.67%",
    watchlistCount: 456,
    participantCount: 987,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$0.8K', down: '$1.2K' },
      '1h': { up: '$1.9K', down: '$2.5K' },
      '1d': { up: '$4.1K', down: '$5.4K' }
    },
    totalVolume: "$670K",
    trend: "neutral",
    tags: ["DeFi", "DEX"]
  },
  {
    coinName: "ATOM",
    symbol: "ATOMUSDT",
    displayName: "Cosmos/USDT",
    currentPrice: 15.67,
    priceChange: "+2.89%",
    watchlistCount: 234,
    participantCount: 654,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$0.6K', down: '$0.8K' },
      '1h': { up: '$1.4K', down: '$1.8K' },
      '1d': { up: '$3.0K', down: '$3.9K' }
    },
    totalVolume: "$340K",
    trend: "up",
    tags: ["Cosmos", "IBC"]
  },
  {
    coinName: "LTC",
    symbol: "LTCUSDT",
    displayName: "Litecoin/USDT",
    currentPrice: 89.12,
    priceChange: "+1.45%",
    watchlistCount: 567,
    participantCount: 1098,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$1.1K', down: '$0.9K' },
      '1h': { up: '$2.6K', down: '$2.1K' },
      '1d': { up: '$5.7K', down: '$4.5K' }
    },
    totalVolume: "$580K",
    trend: "up",
    tags: ["Payment", "Legacy"]
  },
  {
    coinName: "NEAR",
    symbol: "NEARUSDT",
    displayName: "NEAR Protocol/USDT",
    currentPrice: 4.56,
    priceChange: "+6.78%",
    watchlistCount: 345,
    participantCount: 789,
    isWatchlisted: false,
    predictions: {
      '10m': { up: '$1.4K', down: '$0.7K' },
      '1h': { up: '$3.1K', down: '$1.6K' },
      '1d': { up: '$6.7K', down: '$3.2K' }
    },
    totalVolume: "$680K",
    trend: "up",
    tags: ["New", "AI"]
  },
  {
    coinName: "SHIB",
    currentPrice: 0.000024,
    priceChange: "+18.45%",
    watchlistCount: 3456,
    participantCount: 4567,
    isWatchlisted: true,
    predictions: {
      '10m': { up: '$3.4K', down: '$1.8K' },
      '1h': { up: '$7.2K', down: '$3.9K' },
      '1d': { up: '$15.6K', down: '$8.1K' }
    },
    totalVolume: "$2.1M",
    trend: "up",
    tags: ["Meme", "Seed"]
  }
];

export default mockMarkets;
